import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 55513DD6-D73E-438E-8834-D6761C47BA4B
 * name numeric-1-box-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-1-box-multiple-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const Numeric1BoxMultipleOutlineIcon = createSvgIcon(<><path d="M21,17H7V3H21M21,1H7A2,2 0 0,0 5,3V17A2,2 0 0,0 7,19H21A2,2 0 0,0 23,17V3A2,2 0 0,0 21,1M14,15H16V5H12V7H14M3,5H1V21A2,2 0 0,0 3,23H19V21H3V5Z" /></>, 'Numeric1BoxMultipleOutlineIcon');
export default Numeric1BoxMultipleOutlineIcon